import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Modal, Text, Button } from '@dls/web';
import styled from 'styled-components';
import { useMaintenanceData } from '../../hooks/index.js';
import '../../../authentication/context/AuthenticationProvider.js';
import '@geit/ui-components';
import 'react';
import useAppModule from '../../../authentication/hooks/useAppModule.js';
import 'qs';
import 'uuid';
import '../../../authentication/navigate.js';
const ModalBackground = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100%;\n  height: 80vh;\n  background: #fff;\n  top: 120px;\n  left: 0;\n  z-index: 1;\n"])));
const MaintenanceWrapper = _ref => {
  let {
    children,
    featureId
  } = _ref;
  const {
    navigate,
    isFeatureUnderMaintenance
  } = useMaintenanceData();
  const {
    currentFeature
  } = useAppModule();
  const currentFeatureId = (currentFeature == null ? void 0 : currentFeature.featureCode) || (currentFeature == null ? void 0 : currentFeature.featureName);
  const getMaintenanceModal = () => {
    return /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsx(ModalBackground, {}), /* @__PURE__ */jsx(Modal, {
        visible: true,
        title: "Ongoing maintenance",
        onClose: () => navigate("/"),
        children: /* @__PURE__ */jsxs(Modal.Content, {
          children: [/* @__PURE__ */jsx(Text, {
            children: "The feature you are trying to access is currently undergoing maintenance. Please try again later. Thank you."
          }), /* @__PURE__ */jsx("div", {
            className: "mt-3",
            children: /* @__PURE__ */jsx(Button, {
              text: "Okay, got it",
              onClick: () => navigate("/")
            })
          })]
        })
      })]
    });
  };
  return featureId && isFeatureUnderMaintenance(featureId) || currentFeatureId && isFeatureUnderMaintenance(currentFeatureId) ? getMaintenanceModal() : children;
};
export { MaintenanceWrapper };